import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { captureException } from '@sentry/node';
import { fixDateLikeIsoString } from '~/src/helpers/date';
import Layout from '~/src/layout/_layout';
import Promo from '~/src/layout/promo';
import { initialProps } from '~/src/helpers/basePageFunc';
import { selectDomain } from '~/src/store/selectors/domain';
import { getShopItems, EShopCategory, EExpandShopItems } from '~/src/api/content/shop/getShopItems';
import { getPromo } from '~/src/api/promo';

const CATEGORY = {
    NEW: 'new',
    VIEWED: 'viewed',
    CONNECTED: 'active',
    NOCATEGORY: '',
};

const CATEGORY_WEIGHT = {
    [CATEGORY.NEW]: 0,
    [CATEGORY.VIEWED]: 10,
    [CATEGORY.CONNECTED]: 20,
    [CATEGORY.NOCATEGORY]: 30,
};

const EMAIL_WIDGET_TEXT = 'Оставьте почту, чтобы не<br>пропустить новые акции и скидки';

// формируем строку со сроком действия СП
const preparePromoValues = (promoData) => {
    const promos = [];
    if (Array.isArray(promoData)) {
        promoData.forEach(promo => {
            const isItemFromContent = ('billing_id' in promo);
            let fieldActiveTo, fieldId;

            if (isItemFromContent) {
                fieldActiveTo = 'active_to';
                fieldId = 'billing_id';
            } else {
                fieldActiveTo = 'requestStopDate';
                fieldId = 'id';
            }

            if (promo[fieldActiveTo]) {
                const activeToDate = new Date(fixDateLikeIsoString(promo[fieldActiveTo]));
                promo.activeTo = 'Действует до ' + activeToDate.toLocaleDateString('ru');
            } else {
                promo.activeTo = 'Бессрочно';
            }

            promo.id = promo[fieldId];

            promos.push(promo);
        });
    }

    return promos;
};

class PromoPage extends Component {
    static propTypes = {
        tariffs: PropTypes.array,
        hostname: PropTypes.string,
    };

    static async getInitialProps(options) {
        const {
            hostname,
            query: {
                offerId,
                offer_id,
            },
            store,
        } = await initialProps(options);

        const state = store.getState();

        const domain = selectDomain(state);
        const { auth: { accessToken } } = state;

        let discounts = [];

        const shopItems = await getShopItems(
            domain,
            accessToken,
            `${EShopCategory.PartnerServices},${EShopCategory.BonusToAll}`,
            [EExpandShopItems.Category]
        );

        const bonusToAll = shopItems?.filter(item => item.category?.name === EShopCategory.BonusToAll);

        const partnerServices = shopItems?.filter(item => item.category?.name === EShopCategory.PartnerServices);

        const additionalServices = preparePromoValues(partnerServices);

        if (bonusToAll) {
            discounts = bonusToAll.map(item => {
                return {
                    ...item,
                    ...{ isShop: 1 },
                };
            });
        }

        if (accessToken) {
            try {
                const promoItems = await getPromo({ domain: domain }, accessToken);
                const promoValues = preparePromoValues(promoItems.data);

                discounts = [
                    ...promoValues,
                    ...discounts,
                ];
            } catch (err) {
                err.message = 'get discounts failed: ' + err.message;
                captureException(err);
            }
        }

        discounts.sort((offerA, offerB) => (CATEGORY_WEIGHT[offerA.category] - CATEGORY_WEIGHT[offerB.category]));

        return { hostname, offerId: offerId || offer_id, discounts, additionalServices };
    }

    render() {
        const { hostname, offerId, discounts, additionalServices } = this.props;

        return (
            <Layout
                hostname={hostname}
                withMenu={true}
                withHeader={true}
                withChat={true}
                withFooter={true}
                withEmailWidget={true}
                emailWidgetText={EMAIL_WIDGET_TEXT}
                title='Акции интернет-провайдера Дом.ru для авторизованных пользователей'
                description='Воспользуйтесь скидками и подарками для клиентов Дом.ru | Авторизуйтесь, чтобы посмотреть все предложения.'
                relCanonical={`https://${hostname}/promo`}
            >
                <Promo
                    offerId={offerId}
                    discounts={discounts}
                    additionalServices={additionalServices}
                />
            </Layout>
        );
    }
}

export default PromoPage;
